<template>
<div class="chapter">
<div class="inner_page">
<h1 class="FM-head1">Contents</h1>
<p class="toc-text"><a href="#/Chapter1#C1">All That Glitters</a></p>
<p class="toc-text"><a href="#/Chapter2#C2">Recipes</a></p>
<p class="toc-text"><a href="#/Chapter3#C3">Equipment</a></p>
<p class="toc-text"><a href="#/Chapter4#C4">Metallics</a></p>
<p class="toc-text"><a href="#/Part1#P1">Metallic Techniques</a></p>
<p class="toc-text1"><a href="#/Chapter5#C5">Painting</a></p>
<p class="toc-text1"><span href="#/Chapter6#C6" title="Link target outside of Sample">Leafing</span></p>
<p class="toc-text1"><span href="#/Chapter7#C7" title="Link target outside of Sample">Airbrushing</span></p>
<p class="toc-text1"><span href="#/Chapter8#C8" title="Link target outside of Sample">Applying lustre</span></p>
<p class="toc-text"><span href="#/Part2#P2" title="Link target outside of Sample">Cake Projects</span></p>
<p class="toc-text"><span href="#/Chapter9#C9" title="Link target outside of Sample">Imperial Gold</span></p>
<p class="toc-text"><span href="#/Chapter10#C10" title="Link target outside of Sample">Mademoiselle Meringue</span></p>
<p class="toc-text"><span href="#/Chapter11#C11" title="Link target outside of Sample">Artful Appliqué</span></p>
<p class="toc-text"><span href="#/Chapter12#C12" title="Link target outside of Sample">Molten Drizzle</span></p>
<p class="toc-text"><span href="#/Chapter13#C13" title="Link target outside of Sample">Glam Rock Trio</span></p>
<p class="toc-text"><span href="#/Chapter14#C14" title="Link target outside of Sample">Chocolate &amp; Gold Splash</span></p>
<p class="toc-text"><span href="#/Chapter15#C15" title="Link target outside of Sample">Treasured Laurel Lace</span></p>
<p class="toc-text"><span href="#/Chapter16#C16" title="Link target outside of Sample">Fall Foliage</span></p>
<p class="toc-text"><span href="#/Chapter17#C17" title="Link target outside of Sample">Golden Regency</span></p>
<p class="toc-text"><span href="#/Chapter18#C18" title="Link target outside of Sample">Champagne Bubbles</span></p>
<p class="toc-text"><span href="#/Chapter19#C19" title="Link target outside of Sample">Woodland Crown</span></p>
<p class="toc-text"><span href="#/Chapter20#C20" title="Link target outside of Sample">Blush &amp; Gold Colour Block</span></p>
<p class="toc-text"><span href="#/Part3#P3" title="Link target outside of Sample">General Techniques</span></p>
<p class="toc-text1"><span href="#/Chapter21#C21" title="Link target outside of Sample">Assembling</span></p>
<p class="toc-text1"><span href="#/Chapter22#C22" title="Link target outside of Sample">Covering</span></p>
<p class="toc-text1"><span href="#/Chapter23#C23" title="Link target outside of Sample">Dowelling &amp; stacking</span></p>
<p class="toc-text1"><span href="#/Chapter24#C24" title="Link target outside of Sample">Finishing</span></p>
<p class="toc-text"><span href="#/Templates" title="Link target outside of Sample">Templates</span></p>
<p class="toc-text"><span href="#/Suppliers" title="Link target outside of Sample">Suppliers</span></p>
<p class="toc-text"><span href="#/Author" title="Link target outside of Sample">About the author</span></p>
<p class="toc-text"><span href="#/Thanks" title="Link target outside of Sample">Thanks</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?315774a0